import { Option as AccessOption } from '@/react/portainer/access-control/AccessManagement/PorAccessManagementUsersSelector';

import type { Option as PortainerOption } from '@@/form-components/PortainerSelect';
import { isEditableTableMeta } from '@@/datatables/editable/isEditableTableMeta';
import { isIdForNewRow } from '@@/datatables/editable/actionsColumn';

import { MultiUserTeamSelector } from '../../../../MultiUserTeamSelector';

import { columnHelper, type AccessRow } from './helper';

interface AccessColumnProps {
  userTeamOptions: PortainerOption<AccessOption>[];
  users: AccessOption[];
  teams: AccessOption[];
  handleAccessChange: (
    item: AccessRow,
    selection: readonly AccessOption[]
  ) => void;
}

function toOptions(
  row: AccessRow,
  users: AccessOption[],
  teams: AccessOption[]
): AccessOption[] {
  const userMap = new Map(users.map((u) => [u.Id, u]));
  const teamMap = new Map(teams.map((t) => [t.Id, t]));
  const userOpts = row.userIds
    .map((id) => userMap.get(id))
    .filter(Boolean) as AccessOption[];
  const teamOpts = row.teamIds
    .map((id) => teamMap.get(id))
    .filter(Boolean) as AccessOption[];
  return [...userOpts, ...teamOpts];
}

export function createAccessColumn({
  userTeamOptions,
  users,
  teams,
  handleAccessChange,
}: AccessColumnProps) {
  return columnHelper.display({
    id: 'access',
    header: 'Access',
    cell: ({ row: { original, index }, table }) => {
      if (!isEditableTableMeta(table.options.meta)) {
        return null;
      }

      const editableRowIndex = table.options.meta.getEditableRow();
      const opts = toOptions(original, users, teams);
      if (isIdForNewRow(original.id) || index === editableRowIndex) {
        return (
          <MultiUserTeamSelector
            options={userTeamOptions}
            value={opts}
            onChange={(value) => handleAccessChange(original, value)}
          />
        );
      }
      return `${opts.map((o) => o.Name).join(', ')}`;
    },
    meta: {
      className: 'w-2/3',
    },
  });
}
